// extracted by mini-css-extract-plugin
export var avatar = "_jk-3";
export var avatarContainer = "_jk-2";
export var avatarSpacer = "_jk-5";
export var avatarSpacerContainer = "_jk-4";
export var avatarStackContainer = "_jk-1";
export var bubble = "_jk-0";
export var remainderBubble = "_jk-6";